<ng-container *ngIf="tableData">
  <div [ngClass]="{ 'card-panel': tableData.infoTableSectionTitle }">
    <div class="p-3" *ngIf="tableData.infoTableSectionTitle">
      <app-section-title
        [sectionTitleConfig]="tableData.infoTableSectionTitle"
      ></app-section-title>
    </div>
    <div
      *ngFor="let infoTableData of tableData.infoTableData"
      [ngClass]="{
                'pb-4 px-3 px-lg-5 ': tableData.infoTableSectionTitle
            }"
    >
      <div
        class="card-panel"
        [ngStyle]="{
                    'background-color':
                        tableData.infoTableBackground.backgroundColor
                }"
      >
        <div class="card-body">
          <div
            class="table-responsive"
            *ngFor="
                            let header of infoTableData.headers;
                            let i = index
                        "
          >
            <table class="table table-striped info-table">
              <thead>
              <tr>
                <th
                  scope="col"
                  *ngFor="
                                            let headerKey of header
                                                | keyvalue: originalOrder
                                        "
                >
                  {{ headerKey.value }}
                </th>
              </tr>
              </thead>
              <tbody *ngFor="let data of infoTableData.data; let i = index">
              <tr
                [ngStyle]="{
                                          'background-color':
                                              tableData.infoTableBackground
                                                  .rowColor
                                      }"
              >
                <td
                  *ngFor="
                                              let rowKey of infoTableData.data[i]
                                                  | keyvalue: originalOrder
                                          "
                  [innerHTML] ="rowKey.value"
                >
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

